import React, { useContext, useEffect, useRef, useState } from "react";
import Table from "../../components/table/table";
import { UserContext } from "../../contexts/UserContext";
import { GetListeLiveSupAgent } from "../../helpers/api";
import { io } from "socket.io-client";
import Call from "../../assets/icons/Call.svg";
import CallAlert from "../../assets/icons/CallAlert.svg";
import { BASE_URL_SOCKET } from "../../helpers/config";
import { useActionMap } from "../../hooks/useActionMap";

const Live = () => {
  const { user } = useContext(UserContext);
  const [totalPage, setTotalPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [apiResponse, setApiResponse] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const actionMap = useActionMap();

  const socketRef= useRef(null)


  useEffect(() => {
  if (!user?.user?.id) return;
  

  const socket = io(BASE_URL_SOCKET, {
    auth: {
      userId: user.user.id,
      role: user.user.role,
    },
  });
  socketRef.current= socket

  socket.on("newFirstAction", (firstAction) => {

    setApiResponse((prev) => {
      const index = prev.findIndex((s) => s.id === firstAction.id);

      if (index !== -1) {
        const newData = [...prev];
        newData[index] = firstAction;
        return newData;
      }

      return [firstAction, ...prev];
    });
  });

  socket.on('firstActionInProgress', (data)=>{
    setApiResponse((prev)=>prev.filter((item)=>item.userId!== data.clientId))
  })

  return () => {
    socket.off("newFirstAction");
    socket.disconnect();
  };
}, [user?.user?.id, user?.user?.role]);

  useEffect(() => {
    const fetchData = async () => {
      
      try {
        const response = await GetListeLiveSupAgent(
          user?.accessToken,
          currentPage,
          pageSize
        );
        if (response?.success) {
          setApiResponse(response.data)

          setTotalPage(response.total);
          setIsLoading(false);
        }
      } catch (error) {
        console.error("Error:", error);
      }
    };
    if (user?.accessToken) fetchData();
  }, [user?.accessToken]);

  const handleCall = (row) => {
    // const socket = io(BASE_URL_SOCKET);
    const socket = socketRef.current
    if (!socket) return
    socket.emit("callFirstAction", {
      firstActionId: row.id,
      superAgentId : user?.user?.id,
      clientId: row?.userId,
      firstActionType: row?.action,
    });

    // Optionnel : On peut aussi supprimer localement immédiatement pour la réactivité
    setApiResponse((prev) => prev.filter((s) => s.id !== row.id));
  };

  const columns = [
    {
      label: "Order",
      key: "order",
      customRenderers: (row) => (
        <div className="flex flex-col items-start ">
          <span>{row.order}</span>
          {(new Date(row.createdAt)) / 60000 >= 5 && (
            <span className="text-[8px] font-bold  text-[#FF3B30] animate-pulse ">
              RETARD +5 MIN
            </span>
          )}
        </div>
      ),
    },
    {
      label: "Nom du Client",
      key: "firstName",
      customRenderers: (row) => (
        <div>
          <a
            href={`/detailuser/${row.userId}`}
            target="_blank"
            rel="noopener noreferrer"
            className="text-[#777777] underline  hover:text-blue-800"
            onClick={(e) => {
              localStorage.setItem(
                "varaction",
                JSON.stringify({ actionId: row.id, actionType: row.action })
              );
              e.stopPropagation();
            }}
          >
            {row.firstName} {row.lastName}
          </a>
        </div>
      ),
    },
    {
      label: "Email",
      key: "email",
      customRenderers: (row) => <div>{row.email}</div>,
    },
    {
      label: "Pays",
      key: "countryName",
      customRenderers: (row) => <div>{row.countryName}</div>,
    },
    {
      label: "Téléphone",
      key: "phone",
      customRenderers: (row) => <div>{row.phone}</div>,
    },
    {
      label: "Date & heure",
      key: "date",
      customRenderers: (row) => {
        const date = new Date(row.createdAt);

        const formattedDate = date.toLocaleString("fr-FR", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
        });
        const formattedTime = date.toLocaleString("fr-FR", {
          hour: "2-digit",
          minute: "2-digit",
        });

        return (
          <div>
            {formattedDate} <br />
            {formattedTime}
          </div>
        );
      },
    },
    {
      label: "Action",
      key: "action",
      customRenderers: (row) => {
        const actionItem = actionMap[row.action];
        return (
          <>
            {actionItem && (
              <div className="text-left flex items-center gap-2 bg-white rounded-[40px] h-[32px] shadow-[0px_2px_10px_rgba(0,0,0,0.15)] text-[#000] text-[12px] px-2">
                <img src={actionItem.icon} alt="" /> {actionItem.type}
              </div>
            )}
          </>
        );
      },
    },

    {
      label: "Appeler",
      key: "id",
      customRenderers: (row) => (
        <div className="flex justify-start px-2">
          <button
            onClick={(e) => {
              e.stopPropagation();
              handleCall(row);
            }}
          >
            {(new Date(row.createdAt)) / 60000 >= 5 ? (
              <img src={CallAlert} alt="Appel client" />
            ) : (
              <img src={Call} alt="Appel client" />
            )}
          </button>
        </div>
      ),
    },
  ];

  return (
    <div className="bg-white rounded-[10px]  border border-slate-100 p-6">
      <Table
        totalPage={totalPage}
        setPageSize={setPageSize}
        pageSize={pageSize}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        setPageLimit={setPageSize}
        pageLimit={pageSize}
        data={apiResponse}
        columns={columns}
        loading={isLoading}
        excel={true}
        rowClassName={(row) => {
          const diff = (new Date(row.createdAt)) / 60000;
          return diff >= 5
            ? " border-l-4 border-l-[#FF3B30]"
            : "border-l-4  border-l-[#5754E5]";
        }}
      />
    </div>
  );
};

export default Live;
